<template>
    <div class="new-object" :class="isCustomObject ?'custom-object':'system-object'">
        <router-view v-if="$route.params.objectId" />

        <template v-else>
            <!-- <tree-select
                style="margin-bottom:12px"
                :options="evnTypeTree"
                :value="businessEnvId"
                :props="propsConfig"
                :show-prompt="!businessEnvId"
                select-class-name="envType"
                @getValue="onChangeBusinessEnvId($event)"
            /> -->
            <div v-loading="loading.page" class="new-object__content">
                <div v-if="isCustomObject" class="new-object__group group-container">
                    <Group
                        :is-dev-env="isDevEnv"
                        :group-arr="groupArr"
                        :api-param-obj="apiParamObj"
                        :var-obj="varObj"
                        :filter-obj="filterObj"
                        @select-group="selectGroupFn"
                        @edit-group="editGroupFn"
                        @handle-click="handleClick"
                        @add-group="addGroupFn"
                        @add-group-dialog="addGroupDialogFn"
                    />
                    <!-- <div class="new-object__group__btn">
                        <hc-button class="new-object__group__btn--import" @click="showImportDialog=true">
                            导入/更新
                        </hc-button>
                    </div> -->
                    <div v-if="isDevEnv && (isTenantApp ? validPurviewObject.addObject : true)" class="new-object__group__btn">
                        <hc-button type="primary" class="new-object__group__btn--add" @click="openDialogFn('添加')">
                            添加对象
                        </hc-button>
                    </div>
                </div>
                <div v-if="isCustomObject" class="new-object__search">
                    <hc-input v-model="filterObj.keyword" placeholder="请输入搜索关键词" suffix-icon="" @keyup.enter.native="getGroupObjectFnBySearch">
                        <span
                            slot="suffix"
                            class="hc-icon-search hc-input__icon"
                            @click="getGroupObjectFnBySearch"
                        />
                    </hc-input>
                </div>
                <hc-table ref="elTable" v-loading="loading.table" :data="objectArr" class="stripe">
                    <hc-table-column label="序号" type="index" width="80" fixed="left" />
                    <hc-table-column label="显示名称" show-overflow-tooltip prop="title" :width="isCustomObject ? '160': 'auto'" fixed="left" />
                    <hc-table-column
                        v-for="item in tableColumns"
                        :key="item.prop"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width === 'min-width' ? 'auto' :item.width"
                        :min-width="item.width === 'min-width' ? '200' : 'auto'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="{ row }">
                            <span v-if="!row[item.prop]"> -- </span>
                            <span v-else>{{ row[item.prop] }}</span>
                        </template>
                    </hc-table-column>
                    <hc-table-column label="操作" width="200" fixed="right">
                        <template slot-scope="{ row }">
                            <hc-button v-if="isCustomObject && (isTenantApp ? row.isTenant : true)" type="text" :disabled="!isDevEnv || row.isSystem || !row.isEdit" @click="openDialogFn('编辑',row)">
                                编辑
                            </hc-button>
                            <hc-button type="text" @click="objectDetailFn(row)">
                                对象详情
                            </hc-button>
                            <hc-button v-if="isCustomObject && (isTenantApp ? row.isTenant : true)" type="text" :disabled="!isDevEnv || row.isSystem" @click="delObjectFn(row)">
                                删除
                            </hc-button>
                        </template>
                    </hc-table-column>
                </hc-table>
                <div v-if="filterObj.total > 10" class="pagination-wrapper">
                    <hc-pagination
                        class="pagination-wrapper has-top-border"
                        :current-page.sync="filterObj.page"
                        :page-size="filterObj.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="filterObj.total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    />
                </div>
                <hc-dialog v-if="varObj.optBool" :close-on-click-modal="false" :title="`${varObj.optType}对象`" width="480px" :visible.sync="varObj.optBool">
                    <hc-form ref="form" label-position="left" label-width="100px" :model="apiParamObj" :rules="objectRules">
                        <hc-form-item label="显示名称" prop="title">
                            <hc-input v-model.trim="apiParamObj.title" type="text" placeholder="请输入显示名称" size="small" @input="clearspace" />
                        </hc-form-item>
                        <hc-form-item label="对象名称" prop="name" class="object-name">
                            <hc-input v-model.trim="apiParamObj.name" type="text" placeholder="请输入对象名称" size="small">
                                <template v-if="isTenantApp" slot="append">
                                    {{ apiParamObj.customizeField }}
                                </template>
                            </hc-input>
                        </hc-form-item>
                        <hc-form-item label="所属分组" prop="group">
                            <hc-select v-model.trim="apiParamObj.groupId" placeholder="请选择" size="small" style="width: 100%">
                                <hc-option
                                    v-for="item in groupArr"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                                />
                                <div v-if="!isTenantApp" :style="{height: showAddgroup ? '84px' : '44px'}" />
                                <div v-if="!isTenantApp" class="add_group">
                                    <hc-row v-if="showAddgroup" type="flex">
                                        <!-- <hc-col :span="18" class="add_item"> -->
                                        <hc-input v-model="addInput" :maxlength="20" placeholder="请输入分组名" @keyup.enter.native="addGroupbySelect" @input="(val)=>{ addInput = val.replace(groupNameReg,'')}" />
                                        <!-- </hc-col> -->
                                        <!-- <hc-col :span="6"> -->
                                        <hc-button type="text" style="margin-left: 12px;" class="onAddSave" @click="addGroupbySelect">
                                            保存
                                        </hc-button>
                                        <hc-button type="text" @click="showAddgroup = false">
                                            取消
                                        </hc-button>
                                    <!-- </hc-col> -->
                                    </hc-row>
                                    <hc-button icon="hc-icon-plus" type="text" @click="showAddgroup = true; addInput = ''">
                                        新增分组
                                    </hc-button>
                                </div>
                            </hc-select>
                        </hc-form-item>
                        <hc-form-item label="备注" prop="remark" class="object-remark">
                            <hc-input v-model.trim="apiParamObj.remark" type="textarea" placeholder="请输入备注信息" size="small" />
                        </hc-form-item>
                    </hc-form>
                    <div slot="footer">
                        <hc-button type="plain" @click="$set(varObj,'optBool',false)">
                            取消
                        </hc-button>
                        <hc-button :type="varObj.optType === '编辑' ? 'primary' : 'plain'" @click="varObj.optType === '添加' ? addObjectFn() : editObjectFn()">
                            保存
                        </hc-button>
                        <hc-button v-if="varObj.optType === '添加'" type="primary" :loading="loading.dialog" @click="addObjectFn('holdDialog')">
                            保存并新增
                        </hc-button>
                    </div>
                </hc-dialog>
                <import-Dialog v-if="showImportDialog" :dialog-visible.sync="showImportDialog" :tree-config="treeConfig" :save-callback="onImportEvent" @closeDialog="closeImportDialog" />
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { logger } from '@mypaas/app-render-engine/core/sdk'
import * as T from '@common/store/app-resource/types'
// eslint-disable-next-line
// import characterLength from '@common/utils/character-length'
import { APP_RESOURCE } from '@common/store/module-types'
// import * as RouteNames from './types'
import ObjectMixin from './object-mixin'
import EnvList from '../mixins/env-list'
import DataServiceMinxin from '../mixins/data-service'
import Group from '../components/group'

export default {
    name: 'NewObject',
    components: {
        Group,
    },
    mixins: [EnvList, DataServiceMinxin, ObjectMixin],
    data() {
        return {
            showAddgroup: false,
            addInput: '',
            varObj: {},
            groupArr: [],
            columns: [
                {
                    prop: 'name',
                    label: '对象名称',
                    width: 160,
                },
                {
                    prop: 'remark',
                    label: '备注',
                    width: 'min-width',
                },
                {
                    prop: 'createdAt',
                    label: '创建时间',
                    width: 'min-width',
                },
                {
                    prop: 'updatedAt',
                    label: '最后修改时间',
                    width: 'min-width',
                },
                {
                    prop: 'createdBy',
                    label: '创建人',
                    width: 'min-width',
                },
                {
                    prop: 'updatedBy',
                    label: '修改人',
                    width: 'min-width',
                },
            ],
            filterObj: {
                keyword: '',
                groupId: '',
                page: 1,
                pageSize: 10,
                total: 0,
            },
            apiParamObj: {}, // 请求接口的参数
            objectArr: [],

            appId: '',
            loading: {
                page: false,
                dialog: false,
                table: false,
            },
        }
    },
    computed: {
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
        validPurviewObject() {
            return this.$store.state.modeling.validPurview.object || {}
        },
        appInfo() {
            return this.$store.state.modeling.app
        },
        isCustomObject() {
            return this.$route.name === 'ObjectCustomize'
        },
        tableColumns() {
            const { columns } = this
            if (this.isCustomObject) {
                return columns
            }
            return [
                {
                    prop: 'name',
                    label: '对象名称',
                    width: undefined,
                },
                {
                    prop: 'createdBy',
                    label: '创建人',
                    width: 200,
                }]
        },
    },

    watch: {
    },
    beforeDestroy() {
    },
    mounted() {
        this.appId = this.$route.params.appId
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getObjectGroup: T.GET_NEW_OBJECT_GROUP,
            addObjectGroup: T.ADD_NEW_OBJECT_GROUP,
            editObjectGroup: T.EDIT_NEW_OBJECT_GROUP,
            delObjectGroup: T.DEL_NEW_OBJECT_GROUP,
            getObject: T.GET_BUSINESS_OBJECT,
            addObject: T.ADD_NEW_OBJECT,
            editObject: T.EDIT_NEW_OBJECT,
            delObject: T.DEL_NEW_OBJECT,
            importObject: T.IMPORT_OBJECT,
            getSystemObject: T.GET_SYSTEM_OBJECT,
        }),
        clearspace(val) {
            this.apiParamObj.title = val.replace(/\s/g, '')
        },
        // 回复跳往详情前选中的group
        flushGruop() {
            const historyGroup = window.sessionStorage.getItem('@@mn_history_group')
            if (historyGroup) {
                const tempGroup = JSON.parse(historyGroup)
                return this.groupArr.find(item => item.id === tempGroup.groupId)
            }

            return {}
        },
        // 查询分组
        async getObjectGroupFn(loading = true) {
            try {
                this.loading.page = loading
                this.groupArr = await this.getObjectGroup()
                const target = this.flushGruop() || {}
                await this.selectGroupFn(target.id)
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },
        // 选中分组
        selectGroupFn(id) {
            return new Promise((resolve, reject) => {
                this.$set(this.filterObj, 'groupId', id)
                this.filterObj.page = 1
                if (!this.filterObj.groupId) {
                    delete this.filterObj.groupId
                }
                this.getGroupObjectFn(resolve, reject)
            })
        },
        addGroupDialogFn() {
            if (!this.isDevEnv) return
            this.$set(this.varObj, 'addGroupBool', true)
            this.apiParamObj = {}
        },
        async addGroupbySelect() {
            try {
                if (!this.addInput) {
                    return
                }
                this.addInput = this.addInput.replace(/\s/g, '')
                await this.addObjectGroup({
                    params: { title: this.addInput },
                })
                this.addInput = ''
                this.showAddgroup = false
                this.getObjectGroupFn(false)
            } catch (error) {
                this.loading.page = false
            }
        },
        // 新增分组
        async addGroupFn() {
            try {
                if (!this.apiParamObj.title) {
                    this.$set(this.varObj, 'addGroupBool', false)
                    return
                }
                this.loading.page = true
                this.apiParamObj.title = this.apiParamObj.title.replace(/\s/g, '')
                await this.addObjectGroup({
                    webappId: this.appId,
                    ...this.commonParams,
                    envId: this.businessEnvId,
                    params: this.apiParamObj,
                })
                this.apiParamObj = {}
                this.$set(this.varObj, 'addGroupBool', false)
                this.getObjectGroupFn()
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },
        handleClick(val, item) {
            if (val === 'delete') {
                this.delGroupFn(item.id)
            } else {
                this.$set(this.varObj, 'editGroupId', item.id)
                this.$set(this.apiParamObj, 'title', item.title)
            }
        },
        // 编辑分组
        async editGroupFn(id) {
            try {
                if (!this.apiParamObj.title) {
                    this.$set(this.varObj, 'editGroupId', -1)
                    return
                }
                const curGroup = this.groupArr.find(item => item.id === id)
                if (curGroup && (curGroup.title === this.apiParamObj.title)) {
                    this.$set(this.varObj, 'editGroupId', -1)
                    return
                }
                this.loading.page = true
                await this.editObjectGroup({
                    groupId: id,
                    params: { ...this.apiParamObj },
                })
                this.getObjectGroupFn()
                this.apiParamObj = {}
                this.$set(this.varObj, 'editGroupId', -1)
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },
        // 删除分组
        delGroupFn(id) {
            this.$confirm('删除分组将同步删除分组内的业务对象，删除后无法恢复，确定删除？', {
                type: 'warning',
                title: '删除对象分组',
                customClass: 'confirm-box',
                roundButton: false,
            }).then(async () => {
                try {
                    await this.delObjectGroup({
                        groupId: id,
                    })
                    this.$message.success('删除成功')
                    this.getObjectGroupFn()
                // eslint-disable-next-line no-empty
                } catch (error) {}
            }).catch(() => {})
        },
        openDialogFn(type, item) {
            this.$set(this.varObj, 'optBool', true)
            this.$set(this.varObj, 'optType', type)
            const defaultGroupId = (this.groupArr.find(group => group.isSystem) || {}).id
            this.apiParamObj = {
                groupId: this.filterObj.groupId || defaultGroupId,
                remark: '',
                isTenant: false,
            }
            if (item) { // 编辑对象
                this.$set(this.varObj, 'objectId', item.id)
                const reg = new RegExp(`${item.customizeField}$`)
                this.apiParamObj = {
                    groupId: item.groupId || this.filterObj.groupId,
                    name: this.isTenantApp ? item.name.replace(reg, '') : item.name,
                    title: item.title,
                    remark: item.remark,
                    isTenant: false,
                }
            }
            if (this.isTenantApp) {
                this.apiParamObj.isTenant = true
                this.apiParamObj.customizeType = 1
                this.apiParamObj.customizeField = (item && item.customizeField) || '__c'
            }
        },
        getGroupObjectFnBySearch() {
            this.filterObj.page = 1
            this.getGroupObjectFn()
        },
        // 查询分组中的对象列表/查询系统对象列表
        async getGroupObjectFn(resolve, reject) {
            if (!this.loading.page && !this.loading.dialog && !this.varObj.optBool) {
                this.loading.table = true
            }
            const type = this.isCustomObject ? 'getObject' : 'getSystemObject'

            try {
                const resData = await this[type](this.filterObj)
                this.objectArr = resData.items || []
                this.$set(this.filterObj, 'total', resData.total);
                (resolve && typeof resolve === 'function') && resolve()
                this.loading.table = false
                this.updateDesignerDataObjectList()
            } catch (error) {
                (reject && typeof reject === 'function') && reject(error)
                this.loading.table = false
            }
        },

        // 查询系统对象
        async getSystemObjectFn() {
            try {
                await this.getGroupObjectFn()
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },

        // 添加对象
        addObjectFn(bool) {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    try {
                        this.loading.dialog = true
                        await this.addObject(this.apiParamObj)
                        this.apiParamObj = {}
                        this.getGroupObjectFn()
                        if (!bool) {
                            this.$set(this.varObj, 'optBool', false)
                        }
                        const defaultGroupId = (this.groupArr.find(item => item.isSystem) || {}).id
                        this.apiParamObj = {
                            groupId: this.filterObj.groupId || defaultGroupId,
                            remark: '',
                        }
                        if (bool && this.isTenantApp) {
                            this.apiParamObj.isTenant = true
                            this.apiParamObj.customizeType = 1
                            this.apiParamObj.customizeField = '__c'
                        }
                        this.$message.success('新增成功')
                        this.loading.dialog = false
                    } catch (error) {
                        this.loading.dialog = false
                    }
                }
            })
        },
        // 编辑对象
        editObjectFn() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    try {
                        await this.editObject({
                            objectId: this.varObj.objectId,
                            params: { ...this.apiParamObj, fromEnvId: this.appInfo.fromEnvId },
                        })
                        this.getGroupObjectFn()
                        this.$set(this.varObj, 'optBool', false)
                    // eslint-disable-next-line no-empty
                    } catch (error) {}
                }
            })
        },
        // 删除对象
        delObjectFn(row) {
            this.$confirm('对象删除后将无法恢复，确定删除？', {
                type: 'warning',
                title: '删除对象',
                customClass: 'confirm-box',
                roundButton: false,
                closeOnClickModal: false,
            }).then(async () => {
                try {
                    await this.delObject({
                        objectId: row.id,
                    })
                    this.$message.success('删除成功')
                    this.getGroupObjectFn()
                // eslint-disable-next-line no-empty
                } catch (error) {}
            }).catch(() => {})
        },
        objectDetailFn(item) {
            const row = {
                ...item,
                groupId: this.filterObj.groupId,
            }
            window.sessionStorage.setItem('@@mn_history_group', JSON.stringify(row))
            // this.$router.push({
            //     name: RouteNames.OBJECT_DETAIL,
            //     params: {
            //         objectId: row.id, objectName: row.title, businessEnvId: this.businessEnvId, isDevEnv: this.isDevEnv,
            //     },
            // })
            this.$router.push(`${this.$route.fullPath}/${row.id}?objectName=${row.title}&businessEnvId=${this.businessEnvId}&isDevEnv=${this.isDevEnv}&isTenant=${row.isTenant}&fromObjectCustomizeRoute=${this.isCustomObject}`)
        },
        handleSizeChange(val) {
            this.$set(this.filterObj, 'pageSize', val)
            this.getGroupObjectFn()
        },
        handleCurrentChange(val) {
            this.$set(this.filterObj, 'page', val)
            this.getGroupObjectFn()
        },
        // 更改业务对象
        onChangeBusinessEnvId(val) {
            this.businessEnvId = val
            this.loading.page = true
            if (this.isCustomObject) {
                this.getObjectGroupFn()
            } else {
                this.getSystemObjectFn()
            }
        },
        // 导入对象
        async onImportEvent(option) {
            try {
                await this.importObject({
                    webappId: this.appId,
                    ...this.commonParams,
                    params: { fromEnvId: option.importBusinessEnvId, toEnvId: option.targetBusinessEnvId },
                })
                this.getObjectGroupFn()
            } catch (error) {
                logger.log(error)
            }
        },
        getAllEnvListCallBack(env) {
            if (Array.isArray(env) && env.length) {
                const [cur] = env
                this.onChangeBusinessEnvId(cur.id)
            }
        },
    },
}
</script>
<style lang="less">
.hc-tooltip__popper.is-dark{
    word-break: break-all;
}
</style>
<style lang="less">
.hc-time-panel__content::after, .hc-time-panel__content::before {
    margin-top: -10px;
}
.confirm-box{
    .hc-button{
        border-radius: 4px;
        width: 88px;
        height: 32px;
    }
}
.hc-select {
    .hc-input__icon {
        height: initial;
    }
}
.hc-table.stripe {
    th.hc-table__cell {
        background: #FBFBFB;
        padding: 3px 0;

        >.cell {
            font-weight: normal;
        }
    }

    .cell {
        line-height: 32px;
        padding: 0 12px;
    }
}
</style>
<style lang="less" scoped>
@import '../../../assets/less/var.less';
    @deep: ~'>>>';
    /deep/ .hc-table__fixed-right,
    /deep/ .hc-table__fixed{
        height: 100% !important;
    }
    .has-top-border{
        padding-bottom: 16px;
    }
    .add_group{
        padding: 0 12px;
        min-height: 40px;
        width: 100%;
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        & > .hc-row {
            align-items: center;
        }
        .hc-button {
            &:hover,
            &:focus {
                background: #fff;
            }
        }
    }
    .group-container{
        width: 100%;
        overflow: hidden;
    }
    .new-object{
        padding: 16px;
        &__content {
            background: #fff;
            padding: 0 16px 0px;
        }
        &.system-object{
            .new-object__content {
                padding: 16px 16px 0;
            }
        }

        @{deep} .common-container__body {
            padding: 0 24px 24px 24px;
        }
        @{deep} .hc-table{
            .cell{
                white-space: nowrap;
                padding: 0 16px;
            }
        }
        @{deep} .x-title{
            height: 48px !important;
        }
        @{deep} .x-card__content{
            padding:24px;
            padding-top:0px;
        }

        &__group{
            display: flex;
            align-items: center;

            &__wraper{
                flex: 1;
                white-space: nowrap;
                overflow:hidden;
                &__item{
                    padding: 0 16px;
                    display: inline-block;
                    font-size: 14px;
                    color:rgba(0, 0, 0, 0.85);
                    cursor: pointer;
                    &--active{
                        color:rgba(42,106,255,1);
                        position: relative;
                    }
                    &--active::after{
                        content:'';
                        position: absolute;
                        bottom:0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 60px;
                        height: 2px;
                        background:rgba(42,106,255,1);
                    }
                    &__icon{
                        width: 12px;
                        vertical-align: middle;
                        position: relative;
                        bottom:1px;
                        left:3px;
                        opacity: 0;
                    }
                }
                &__item:nth-child(1) ~ &__item:hover img{
                    opacity: 1;
                }
                &__item:nth-child(2) ~ &__item{
                    padding: 0 8px;
                    >span{
                        padding-left:12px;
                    }
                }
                @{deep} .hc-input{
                    width: 120px;
                    height: 32px;
                    .hc-input__inner{
                        padding:0 28px 0 8px;
                        text-align: center;
                    }
                }
                .add-group-btn{
                    position: relative;
                    top: 2px;
                    margin-left:16px;
                    color: #e2e5f0;
                    cursor: not-allowed;
                    &--actived {
                        cursor: pointer;
                        color: #1F4FFF;
                    }
                }
            }
            &__btn{
                &--import{
                    width: auto;
                    padding: 7px 10px;
                    font-size: 14px;
                    height: 36px;
                    margin-right: 8px;
                }
            }
        }
        &__search{
            margin:8px 0;
            @{deep} .hc-input{
                width: 300px;
                height: 36px;
                .hc-input__inner{
                    height: 32px !important;
                }
            }
        }
        @{deep} .hc-table{
            // margin-top:10px;
        }
        @{deep} .hc-dialog__header{
            background: #fff;
            height: 56px;
            .hc-dialog__headerbtn{
                right: 20px;
                top: 18px;
            }
        }
        @{deep} .hc-dialog__body{
            .hc-select{
                display: block;
            }
        }
        @{deep} .hc-dialog__footer{
            .hc-button--plain{
                width: 88px;
                color:rgba(62, 67, 82, 1);
                border-radius: 4px;
            }
            .hc-button--primary{
                box-shadow:0px 2px 4px 0px rgba(0,0,0,0.15);
                border-radius: 4px;
            }
        }
    }
    .icon-placeholder{
        display: inline-block;
        width: 12px;
        height: 12px;
    }

    @{deep} .hc-form-item.object-name {
        min-height: 56px;
        margin-bottom: 0;

        .hc-form-item__error {
            position: relative;
        }
    }
</style>
